import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

import useFormValidation from 'hooks/useFormValidation';

import { adminSequenceApi } from 'api';

const validationSchema = {
  prefix: {
    required: 'Prefix is required',
  },
};

const initialValues = {
  seq_type: '',
  prefix: '',
};

const SequenceEditModal = ({ show, onHide, onSuccess, sequence }) => {
  const [isLoading, setIsLoading] = useState(false);

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    validateForm,
    resetForm,
    isValid,
  } = useFormValidation(initialValues, validationSchema);

  useEffect(() => {
    if (show && sequence) {
      handleChange('seq_type', sequence.seq_type || '');
      handleChange('prefix', sequence.prefix || '');
    }
  }, [show, sequence, handleChange]);

  const handleSubmit = async e => {
    e.preventDefault();

    if (!validateForm()) return;

    setIsLoading(true);
    try {
      await adminSequenceApi.updateSequence([
        {
          seq_type: values.seq_type,
          prefix: values.prefix,
        },
      ]);

      toast.success('Sequence updated successfully');
      onSuccess();
      closeModal();
    } catch (err) {
      toast.error('Failed to update sequence');
    } finally {
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    resetForm();
    onHide();
  };

  return (
    <Modal show={show} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>Sequence Update</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Sequence Type</Form.Label>
            <Form.Control
              type="text"
              value={values.seq_type}
              disabled
              readOnly
              className="bg-light"
            />
            <Form.Text className="text-muted">
              Sequence Type cannot be modified
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              Prefix<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              value={values.prefix}
              onChange={e => handleChange('prefix', e.target.value)}
              onBlur={() => handleBlur('prefix')}
              isInvalid={touched.prefix && errors.prefix}
            />
            <Form.Control.Feedback type="invalid">
              {errors.prefix}
            </Form.Control.Feedback>
          </Form.Group>

          <Button type="submit" hidden />
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={!isValid || isLoading}
        >
          {isLoading ? 'Saving...' : 'Save Changes'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SequenceEditModal;
